function TabButton({ label, isActive, onClick, disabled = false }) {
  // 모바일에서 짧은 텍스트로 변경
  const getShortLabel = (label) => {
    if (label === '지도로 보기') return '지도';
    if (label === '목록으로 보기') return '목록';
    if (label === '상담 및 관리') return '상담';
    return label;
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        px-2 md:px-6 py-1.5 md:py-3 font-medium transition-colors text-xs md:text-lg
        whitespace-nowrap
        ${disabled 
          ? 'bg-transparent text-gray-400 cursor-not-allowed opacity-50' 
          : isActive 
            ? 'bg-orange-500 text-white shadow-md' 
            : 'bg-orange-100 text-orange-800 hover:bg-orange-200'
        }
      `}
      title={label} // 전체 텍스트를 툴팁으로 표시
    >
      <span className="hidden md:inline">{label}</span>
      <span className="md:hidden">{getShortLabel(label)}</span>
    </button>
  );
}

export default TabButton;